import { render, staticRenderFns } from "./VideoCenter.vue?vue&type=template&id=07c68bf2&scoped=true&"
import script from "./VideoCenter.vue?vue&type=script&lang=js&"
export * from "./VideoCenter.vue?vue&type=script&lang=js&"
import style0 from "./VideoCenter.vue?vue&type=style&index=0&id=07c68bf2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c68bf2",
  null
  
)

export default component.exports